/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-10-01
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../crud/base-crud.service';
import { API_CONFIG } from '../crud/api.config';
import { PageResponse } from '../crud/crud.types';

/** Un favorito como lo guarda masters: la pantalla, por la clave de su ruta, y su posicion. */
export interface FavoritoRemoto {
  id: number;
  ruta: string;
  orden?: number | null;
}

/** Lo que se envia para marcar una pantalla. El dueño lo pone el servidor desde el token. */
export interface FavoritoNuevo {
  ruta: string;
  orden?: number;
}

/**
 * Acceso a los favoritos del usuario en nebula-masters (`/api/v1/favoritos`).
 *
 * <p>El servidor responde solo con los favoritos del usuario del token: no hay filtro de dueño
 * que enviar.</p>
 */
@Injectable({ providedIn: 'root' })
export class FavoritosApi extends BaseCrudService<FavoritoRemoto, FavoritoNuevo, FavoritoNuevo> {
  /** Tope de favoritos que se leen de una vez: una lista de menu, no un listado. */
  static readonly TOPE = 200;

  constructor() {
    super();
    const config = API_CONFIG.masters;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.favoritos}`);
  }

  /**
   * Los favoritos del usuario en sesion, en su orden, por el `page-response` canonico.
   *
   * @returns la pagina con los favoritos.
   */
  listar(): Observable<PageResponse<FavoritoRemoto>> {
    return this.getPageRecordQuery<FavoritoRemoto>({
      page: 0,
      size: FavoritosApi.TOPE,
      ordersBy: [
        { column: 'orden', direction: 'ASC' },
        { column: 'id', direction: 'ASC' },
      ],
    });
  }
}
